// Must match backend/app/content_intelligence/dark_launch.py. The backend remains
// authoritative; this copy only prevents non-cohort cards from showing a dead CTA.
const MOVIES = [
  915935, 19995, 346698, 693134, 545611, 419430, 27205, 803796, 872585, 496243,
  666277, 792307, 687163, 579974, 1233413, 569094, 129, 1061474, 24428, 238,
  933260, 467244, 269149, 329865, 264660,
];
const SERIES = [
  66732, 1399, 106379, 1408, 200875, 60622, 95479, 4087, 44217, 60625,
  73586, 15260, 2190, 76479, 93405, 94997, 95396, 100088, 136315, 85271,
  46952, 34307, 60572, 456, 1434,
];

export const DARK_LAUNCH_KEYS = new Set([
  ...MOVIES.map((id) => `tmdb:movie:${id}`),
  ...SERIES.map((id) => `tmdb:series:${id}`),
]);

export const contentIntelligenceDarkLaunch =
  process.env.REACT_APP_CONTENT_INTELLIGENCE_DARK_LAUNCH !== 'false';

